import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Fabricantedistribuidor } from 'src/app/model/Fabricantedistribuidor';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FabricantedistribuidorService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<Fabricantedistribuidor[]> {
    return this.http.get<Fabricantedistribuidor[]>(`${environment.apiUrl}/view/fabricantedistribuidor`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/view/fabricantedistribuidor/${id}`);
  }

  findByIdExample(id: number) { }

  save(fabricantedistribuidor: Fabricantedistribuidor) {
    return this.http.post(`${environment.apiUrl}/view/fabricantedistribuidor`, fabricantedistribuidor);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/view/fabricantedistribuidor/${id}`);
  }
}
